import { useEffect, useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { Link } from "react-router-dom";
import { Select } from "antd";
import { toast } from "sonner";
import Avvvatars from "avvvatars-react";
import { getAllClass } from "../../api/pedagogicElement";
import { useAcademicYear } from "../../core/common/context/AcademicYearContext";
import { getStudentRegistrationByClass } from "../../api/etudiants";
import { generateFrequentation } from "../../api/docs";
import {
  Action,
  buildPermissionContext,
  Resource,
} from "../../core/common/autorisations/permissionsMap";

const Frequentation = () => {
  // 👉 Etats pour la sélection de l'année académique en cours
  const { selectedYear, setSelectedYear } = useAcademicYear();

  // 👉 Etats pour la sélection des classes et étudiants
  const [allClasses, setallClasses] = useState<any[]>([]);
  const [allStudent, setAllStudent] = useState<any[]>([]);
  const [selectedClass, setSelectedClass] = useState<any>(null);
  const [selectedStudent, setSelectedStudent] = useState<any>(null);

  // 👉 Etats pour le chargement des classes, périodes et UE
  const [isLoadingClasses, setIsLoadingClasses] = useState(false);
  const [isLoadingStudents, setIsLoadingStudents] = useState(false);
  const [isFileLoading, setIsFileLoading] = useState(false); // Pour la génération de la fiche

  const [iframeVisible, setIframeVisible] = useState(false);

  // state pour le PDF
  const [pdfBlobUrl, setPdfBlobUrl] = useState<string | null>(null);

  // 👉 Change handler pour le select des classes
  const handleClassChange = (selectedId: string) => {
    const selected = allClasses.find(
      (c: any) => c.id.toString() === selectedId,
    );
    if (selected) setSelectedClass(selected);
    setSelectedStudent(null);
  };

  // 👉 Change handler pour le select des étudiants
  const handleStudentChange = (selectedId: string) => {
    const selected = allStudent.find(
      (c: any) => c.StudentProfil.id.toString() === selectedId,
    );
    if (selected) setSelectedStudent(selected);
  };

  // Fontion pour générer un relevé denotes selon la périod , année academique , la classe et l'étudiant
  const generateCertificateFrequentation = async () => {
    try {
      const response = await generateFrequentation({
        id_studentProfil: selectedStudent?.StudentProfil?.id,
        id_academicYear: selectedYear?.id,
      });
      // console.log("releve generation : ", response);
      const blob = new Blob([response], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      setPdfBlobUrl(url);
      setIframeVisible(true);
      // console.log("relevé généré: ", response);
      toast.success("Fiche d'émargement généré avec succès");
    } catch (error: any) {
      // console.log("erreur génération fiche d'émargement: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    } finally {
      setIsFileLoading(false); // ← Toujours arrêter le chargement à la fin
    }
  };

  /**
   * 👉 Chargement des classes disponibles pour l'année académique sélectionnée
   * - Dépend de selectedYear
   * - Charge toutes les classes et sélectionne automatiquement la première si dispo
   */
  useEffect(() => {
    // On attend que selectedYear soit défini
    if (!selectedYear?.id) return;
    setIsLoadingClasses(true);
    setIsLoadingStudents(false);
    setSelectedStudent(null);

    const fetchClasses = async () => {
      try {
        const response = await getAllClass(
          selectedYear?.id,
          buildPermissionContext(Resource.FREQUENTATION, Action.CREATE),
        );
        const classes = response.data || [];

        setallClasses(classes);

        // Sélectionne la première classe automatiquement s'il y en a
        if ((classes || []).length > 0) {
          setSelectedClass(classes[0]);
        }
      } catch (error: any) {
        // console.log("erreur de chargement des classes : ", error);
        toast.error(
          error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            "Une erreur s'est produit, Réessayer plus tard",
        );

        // Option: reset les classes en cas d'erreur
        setallClasses([]);
      } finally {
        setIsLoadingClasses(false); // ← Toujours arrêter le chargement à la fin
      }
    };

    fetchClasses();
  }, [selectedYear]);

  /**
   * 👉 Chargement des étudiants disponibles pour la classe sélectionnée
   * - Dépend de la classe
   * - Charge tous les étudiants et sélectionne automatiquement la première si dispo
   */
  useEffect(() => {
    // On attend que selectedYear soit défini
    if (!selectedClass?.id) return;
    setIsLoadingStudents(true);

    const fetchStudents = async () => {
      try {
        const response = await getStudentRegistrationByClass(
          selectedClass?.id,
          buildPermissionContext(Resource.FREQUENTATION, Action.CREATE),
        );
        const students = response.data || [];

        setAllStudent(students);

        // Sélectionne le premier étudiant automatiquement s'il y en a
        if ((students || []).length > 0) {
          setSelectedStudent(students[0]);
        }
      } catch (error: any) {
        // console.log("erreur de chargement des étudiants : ", error);
        toast.error(
          error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            "Une erreur s'est produit, Réessayer plus tard",
        );

        // Option: reset les étudiants en cas d'erreur
        setAllStudent([]);
      } finally {
        setIsLoadingStudents(false); // ← Toujours arrêter le chargement à la fin
      }
    };

    fetchStudents();
  }, [selectedClass]);

  return (
    <>
      {/* Chat */}
      <div
        className="chat chat-messages"
        style={{ border: "1px solid #B5B9C3" }}
        id="middle"
      >
        {/* Header conservé */}
        <div
          className="chat-header"
          style={{ borderBottom: "1px solid #B5B9C3" }}
        >
          <div className="user-details">
            <div className="bg-primary-light rounded-circle p-2 me-3">
              <i className="ti ti-file-certificate fs-4" />
            </div>
            <div>
              <h4>Certificat de Fréquentation</h4>
            </div>
          </div>
          <div className="chat-options">
            <ul className="list-inline">
              <li className="list-inline-item">
                <Link
                  className="btn btn-outline-light no-bg"
                  to="#"
                  data-bs-toggle="dropdown"
                >
                  <i className="bx bx-dots-vertical-rounded" />
                </Link>
                <div className="dropdown-menu dropdown-menu-end">
                  <Link to="#" className="dropdown-item">
                    <span>
                      <i className="bx bx-x" />
                    </span>
                    Close Chat
                  </Link>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Contenu remplacé par l'iframe */}
        {iframeVisible && pdfBlobUrl ? (
          <iframe
            src={pdfBlobUrl}
            style={{
              width: "100%",
              height: "calc(100vh - 80px)", // Ajustez selon la hauteur du header
              border: "none",
              marginTop: "10px",
            }}
            title="Aperçu PDF"
            onError={(e) => {
              // console.error("Erreur de chargement du PDF", e);
              // Gestion d'erreur optionnelle
            }}
          />
        ) : (
          <div
            className="d-flex flex-column align-items-center justify-content-center"
            style={{ height: "calc(100vh - 80px)" }}
          >
            {/* Version sobre */}
            <div className="text-center p-4">
              <div className="bg-light rounded-circle p-4 mb-3 d-inline-flex">
                <i className="bx bx-file-blank fs-1 text-muted"></i>
              </div>
              <h4 className="text-muted mb-2">
                {pdfBlobUrl ? "Chargement du PDF..." : "Aucun PDF à afficher"}
              </h4>
              <p className="text-muted">
                {!pdfBlobUrl && "Générez un nouveau PDF pour l'afficher ici"}
              </p>
            </div>
          </div>
        )}
      </div>
      {/* /Chat */}
      {/* Right sidebar */}
      <div
        className="right-sidebar right_sidebar_profile right-side-contact show-right-sidebar"
        id="middle1"
        style={{ borderTop: "1px solid #B5B9C3" }}
      >
        <div className="right-sidebar-wrap active">
          <div className="slimscroll">
            <Scrollbars>
              <div className="sidebar-body">
                <div className="mt-0 right_sidebar_logo">
                  {selectedStudent ? (
                    <div className="text-center right-sidebar-profile">
                      <div className=" d-flex justify-content-center mb-3">
                        <Avvvatars
                          value={`${selectedStudent.StudentProfil.firstname?.charAt(0) || ""}${
                            selectedStudent.StudentProfil.lastname?.charAt(0) ||
                            ""
                          }`}
                          style="character" // ou "character"
                          size={90}
                        />
                      </div>
                      <h5 className="profile-name">{`${selectedStudent.StudentProfil.firstname} ${selectedStudent.StudentProfil.lastname}`}</h5>
                      <div className="last-seen-profile">
                        <span>{`${selectedClass.Level.label} - ${selectedClass.label}`}</span>
                      </div>
                    </div>
                  ) : (
                    <div className="d-flex flex-column align-items-center justify-content-center h-100 py-4">
                      <div className="bg-light rounded-circle p-4 mb-3">
                        <i className="bx bx-user-x fs-1 text-muted"></i>
                      </div>
                      <h5 className="text-muted mb-2">
                        Aucun étudiant sélectionné
                      </h5>
                      <p className="text-muted text-center small">
                        Sélectionnez un étudiant dans la liste pour afficher les
                        détails
                      </p>
                    </div>
                  )}
                  <div className=" chat-member-details mb-2">
                    <label className="form-label">Classe</label>
                    <Select
                      showSearch
                      optionFilterProp="label"
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toString()
                          .toLowerCase()
                          .includes(input.toString().toLowerCase())
                      }
                      size="large"
                      style={{ width: "100%" }}
                      placeholder="Sélectionner la classe"
                      value={selectedClass?.id?.toString()}
                      onChange={handleClassChange}
                      options={allClasses
                        .slice()
                        .sort((a: any, b: any) => {
                          const levelCompare = a.Level.label.localeCompare(
                            b.Level.label,
                            "fr",
                            { numeric: true },
                          );
                          if (levelCompare !== 0) return levelCompare;
                          return a.label.localeCompare(b.label, "fr", {
                            numeric: true,
                          });
                        })
                        .map((classe: any) => ({
                          label: `${classe.Level.label} - ${classe.label}`,
                          value: classe.id.toString(),
                        }))}
                      className="mb-2"
                    />

                    <label className="form-label">Étudiant</label>
                    <Select
                      showSearch
                      optionFilterProp="label"
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toString()
                          .toLowerCase()
                          .includes(input.toString().toLowerCase())
                      }
                      size="large"
                      style={{ width: "100%" }}
                      placeholder="Sélectionner un étudiant"
                      value={selectedStudent?.StudentProfil?.id?.toString()}
                      onChange={handleStudentChange}
                      options={allStudent.map((student: any) => ({
                        label: `${student.StudentProfil.firstname} - ${student.StudentProfil.lastname}`,
                        value: student.StudentProfil.id.toString(),
                      }))}
                      className="mb-2"
                    />
                  </div>
                </div>
              </div>
              <div className="right-sidebar-head share-media">
                <div className="d-grid gap-2 mb-4">
                  {isFileLoading ? (
                    <button
                      className="btn btn-primary-light"
                      type="button"
                      disabled={false}
                    >
                      <span
                        className="spinner-border spinner-border-sm align-middle me-1"
                        role="status"
                        aria-hidden="true"
                      />
                      Chargement...
                    </button>
                  ) : (
                    <button
                      onClick={async () => {
                        if (
                          !selectedClass ||
                          !selectedStudent ||
                          !selectedYear
                        ) {
                          toast.error("Veuillez sélectionner un étudiant");
                          return;
                        }
                        try {
                          setIsFileLoading(true);
                          await generateCertificateFrequentation();
                        } catch (error) {
                          // console.error("Erreur de génération:", error);
                          toast.error("Échec de la génération du fichier");
                        } finally {
                          setIsFileLoading(false);
                        }
                      }}
                      className="btn btn-primary"
                      type="button"
                    >
                      Génerer
                    </button>
                  )}
                </div>
              </div>
            </Scrollbars>
          </div>
        </div>
      </div>
      {/* Right sidebar */}
    </>
  );
};

export default Frequentation;
